/**
 * 能力项内嵌表单
 * @author 3173
 * @date 2020-07-18
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import { Col } from 'antd'
import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer } = framework_tool;
let { WizForm, WizButton } = component_tool;

class AbilityItemForm extends WizContainer {

  componentName = 'abilityItemForm';

  static propTypes = {
    addAbilityItem: PropTypes.func,
    abilityItemData: PropTypes.array
  };

  constructor(props) {
    super(props);
    this.state = {
    };
  }


  /** 添加能力项 */
  _addItem() {
    let { addAbilityItem,item } = this.props;
    if (this.refs.abilityItemForm && this.refs.abilityItemForm.validateFields) {
      this.refs.abilityItemForm.validateFields((err, values) => {
        if (!err) {
          if (addAbilityItem) {
            if (item && item.key) {
              values.key = item.key;
              values.update = true;
            }else {
              values.key = new Date().getTime() + '_abilityItem';
            }
            if(item && item.state !== values.state && values.state===0){
              values.tips = true
            }
            addAbilityItem(values);
            this.refs.abilityItemForm.setFieldsValue({ name: '', state: 1 })
          }
        }
        return
      });
    }
  }

  validateNameRepeat = (rule, value, callback) => {
    let { abilityItemData, item } = this.props;
    abilityItemData.forEach((data, index) => {
      if (data.name === value && (item && item.key != data.key)) {
        callback('能力项名称已存在');
      }
    });
    callback();
  }


  _render() { 
    const columns = [
      {
        name: "id",
        formItem: {
          type: "hidden"
        }
      },
      {
        title: "能力项名称",
        name: "name",
        dataIndex: "name",
        formItem: {
          maxlength: 15,
          placeholder: '能力项名称最多输入15个字',
          rules: [{
            required: true,
            message: '请输入能力项名称',
          },
          {
            pattern: /^[A-Za-z\d_\-\u4e00-\u9fa5]{1,15}$/,
            message: '能力项名称不允许使用特殊符号'
          },
          { validator: this.validateNameRepeat }
          ],
          initialValue: this.props.item && this.props.item.name ? this.props.item.name : null
        },
      },
      {
        title: '状态',
        name: 'state',
        dataIndex: 'state',
        formItem: {
          type: 'Radio',
          rules: [{
            required: true,
            message: '请选择状态',
          }],
          initialValue: this.props.item && (this.props.item.state||this.props.item.state==0) ? this.props.item.state : 1
        },
        dict: [
          { code: 1, codeName: "有效" },
          { code: 0, codeName: "无效" }
        ],
      },
      {
        title: '是否展示',
        name: 'exhibition',
        dataIndex: 'exhibition',
        formItem: {
          type: 'Radio',
          rules: [{
            required: true,
            message: '请选择展示状态',
          }],
          initialValue: this.props.item && (this.props.item.exhibition||this.props.item.exhibition==0) ? this.props.item.exhibition : 1
        },
        dict: [
          { code: 1, codeName: "是" },
          { code: 0, codeName: "否" }
        ],
      }
    ]

    let onSubmit = this._addItem.bind(this);

    let formProps = {
      ref: 'abilityItemForm',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: <Col className="form-btns col-item"><WizButton type="primary" onClick={this._addItem.bind(this)}>保存</WizButton></Col>,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      },
      style: { width: '100%' }
    }

    return (
      <WizForm key='abilityItemForm' className={'form-inline'} {...formProps} />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

export default connect(mapStateToProps)(AbilityItemForm);
